module.exports = __webpack_public_path__ + "img/wf-home.5e8b6f22.svg";